// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.79575 16.2884L6.08705 15.0001L4.79575 13.7115L6.20847 12.2958L8.91859 15.0002L6.20835 17.7043L4.79575 16.2884Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0 3H7.41421L11 6.58579V3H18.4142L24 8.58579V21H0V3ZM11 19V11H5V5H2V19H11ZM7 5.41421V9H10.5858L7 5.41421ZM18 5.5V9H21.5L18 5.5ZM19.2041 16.2883L17.9128 14.9999L19.2041 13.7113L17.7914 12.2956L15.0813 15L17.7915 17.7041L19.2041 16.2883Z"}}]};

const FileTransmitDoubleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-transmit-double-filled',
    ref,
    icon: element,
  },
));

FileTransmitDoubleFilledIcon.displayName = 'FileTransmitDoubleFilledIcon';

export default FileTransmitDoubleFilledIcon;
